// The redirects of the Admin shell. `/admin` opens Home. The addresses of the
// View → Administration page before the Admin shell open the matching Admin
// page, so a saved link or a bookmark still works.

import { Navigate, useParams } from 'react-router';

/** A fixed redirect: `/admin`, `/view/administration` and its welcome pack. */
export function AdministrationRedirect({ to }: { to: string }) {
    return <Navigate to={to} replace />;
}

/** `/view/administration/ingest-plans/:id`. */
export function IngestPlanRedirect() {
    const { id } = useParams();
    return <Navigate to={id ? `/admin/uploads/plans/${id}` : '/admin/uploads'} replace />;
}
